import { render, staticRenderFns } from "./InstagramCommentDelete.vue?vue&type=template&id=58fa10f0"
import script from "./InstagramCommentDelete.vue?vue&type=script&lang=js"
export * from "./InstagramCommentDelete.vue?vue&type=script&lang=js"
import style0 from "./InstagramCommentDelete.vue?vue&type=style&index=0&id=58fa10f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports